import { trackAdClick } from './trackClick';

/**
 * Carte produit sponsorisé d'un partner_block.
 * - Image carrée lazy-loadée avec dimensions explicites (CLS = 0)
 * - Clic : ping /api/ads/{id}/click {item_type:'product', item_id} puis window.open
 * - rel="sponsored nofollow noopener" pour respect SEO/CNIL
 */
export default function ProductCard({ adId, product }) {
  const handleClick = (e) => {
    // On laisse le clic middle/cmd ouvrir normalement dans un nouvel onglet.
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      trackAdClick(adId, { itemType: 'product', itemId: product.id });
      return;
    }
    e.preventDefault();
    trackAdClick(adId, { itemType: 'product', itemId: product.id });
    window.open(product.click_url, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={product.click_url}
      onClick={handleClick}
      rel="sponsored nofollow noopener"
      target="_blank"
      aria-label={`${product.alt_text || product.title} — lien sponsorisé, nouvel onglet`}
      className="group flex flex-col gap-2 text-current no-underline focus:outline-none focus:ring-2 focus:ring-[#D62828] focus:ring-offset-2 rounded-md"
    >
      <div className="aspect-square overflow-hidden rounded-md bg-muted">
        <img
          src={product.image_url}
          alt={product.alt_text || product.title}
          width={400}
          height={400}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 motion-reduce:transition-none motion-reduce:transform-none"
        />
      </div>
      <h3 className="text-sm font-medium text-foreground leading-snug line-clamp-2 min-h-[2.6em]">
        {product.title}
      </h3>
      <span className="inline-flex self-start items-center px-3 py-1.5 rounded-md bg-[#D62828] text-white text-xs font-semibold transition-colors group-hover:bg-[#B51E1E] motion-reduce:transition-none">
        Découvrir
      </span>
    </a>
  );
}
